var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6881 18.3285L8.24407 18.3285C8.61916 14.946 10.3266 12.2066 12.8945 10.6401L12.8945 10.579L0.871286 10.579L0.871286 8.3556L12.8962 8.3539L12.8962 8.2928C10.3283 6.72625 8.62085 3.98692 8.24577 0.604332H10.6898C11.1429 4.50288 13.7431 7.88377 18.5972 8.51174L18.5972 10.4228C13.7448 11.0491 11.1429 14.4317 10.6898 18.3302L10.6881 18.3285Z",
    fill: "#193F28"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.4bbfa2933cd60c8d69ac77e29a596ebe.svg";
export { ForwardRef as ReactComponent };